import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=b54e6a14&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServices.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=b54e6a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54e6a14",
  null
  
)

export default component.exports